import type { MenuItem } from 'primereact/menuitem'
import { MegaMenu } from 'primereact/megamenu'
import { useLocation, useNavigate } from 'react-router'
import { topNavTexts } from './texts'
import styles from './TopNavMenu.module.css'
import { getActiveKnowledgeDatabaseTenantId, getActiveTopNavItem, getBookingSearchPath, getKnowledgeDatabaseEntryPath, knowledgeDatabaseEntries } from './topNavModel'

export function TopNavMenu() {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const activeItem = getActiveTopNavItem(pathname)
  const activeTenantId = getActiveKnowledgeDatabaseTenantId(pathname)

  const model: MenuItem[] = [
    {
      label: topNavTexts.bookingSearch,
      className: activeItem === 'bookingSearch' ? styles.active : undefined,
      command: () => {
        void navigate(getBookingSearchPath())
      },
    },
    {
      label: topNavTexts.knowledgeDatabase,
      className: activeItem === 'knowledgeDatabase' ? styles.active : undefined,
      items: [
        [
          {
            label: topNavTexts.knowledgeDatabase,
            items: knowledgeDatabaseEntries.map(entry => ({
              label: entry.label,
              command: () => {
                void navigate(getKnowledgeDatabaseEntryPath(entry))
              },
              template: (_item, options) => (
                <a
                  href={getKnowledgeDatabaseEntryPath(entry)}
                  tabIndex={-1}
                  data-pc-section="action"
                  className={`${options.className} ${styles.item}`}
                >
                  <span className={`${styles.label} ${entry.tenantId === activeTenantId ? styles.labelActive : ''}`}>{entry.label}</span>
                  <span className={styles.description}>{entry.description}</span>
                </a>
              ),
            })),
          },
        ],
      ],
    },
  ]

  return <MegaMenu model={model} className={styles.topNav} />
}
